import { render } from "./RedirectingModal.vue?vue&type=template&id=36eee2ad&scoped=true"
import script from "./RedirectingModal.vue?vue&type=script&lang=js"
export * from "./RedirectingModal.vue?vue&type=script&lang=js"

import "./RedirectingModal.vue?vue&type=style&index=0&id=36eee2ad&scoped=true&lang=css"

import exportComponent from "/app/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36eee2ad"]])

export default __exports__